import stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  container: {
    backgroundColor: palette['greyWhite'],
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: anatomy['size-24'],
    height: '100vh',
    '@media (max-width: 680px)': {
      paddingTop: '53px',
    },
  },
  title: {
    fontSize: anatomy['size-44'],
    fontFamily: fonts.din2014Demi,
    color: palette['grey-950'],
    textAlign: 'center',
    '@media (max-width: 680px)': {
      fontSize: anatomy['size-36'],
    },
  },
  subTitle: {
    fontSize: '18px',
    fontFamily: fonts.din2014Regular,
    color: palette['darked-70'],
    textAlign: 'center',
    '@media (max-width: 680px)': {
      fontSize: anatomy['size-16'],
    },
  },
});
